import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
  selector: '[bdMinDate], [bdMaxDate]',
  standalone: false,
  providers: [{provide: NG_VALIDATORS, useExisting: DateRangeDirective, multi: true}]
})
export class DateRangeDirective implements Validator {


  @Input() minDate: Date;
  @Input() maxDate: Date;

  constructor() {
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validateDate(control);
  }

  private validateDate(control: AbstractControl) {

    if (!control || !control.value) {
      return null;
    }

    const dateToCheck = control.value;

    if ( !!this.minDate && this.minDate > dateToCheck) {
      return {minDate: this.minDate};
    }

    if ( !!this.maxDate && this.maxDate < dateToCheck) {
      return {maxDate: this.maxDate};
    }

    return null;
  }
}

